export const formulaData = [
    {
        "level": " EDEXCEL Pure Mathematics P1",
        "title": "Mensuration",
        "formula": [
            "4\\pi r^2",
            "\\pi \\times \\text{slant height}"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P1",
        "title": "Cosine rule",
        "formula": [
            "a^2 = b^2 + c^2 - 2bc \\cos A"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P2",
        "title": "Arithmetic series",
        "formula": [
            "u_n = a + (n - 1)d",
            "S_n = \\frac{1}{2} n (a + l) = \\frac{1}{2} n [2a + (n - 1)d]"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P2",
        "title": "Geometric series",
        "formula": [
            "u_n = ar^{n-1}",
            "S_n = \\frac{a(1 - r^n)}{1 - r}",
            "S_\\infty = \\frac{a}{1 - r} \\quad \\text{for } |r| < 1"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P2",
        "title": "Logarithms and exponentials",
        "formula": [
            "\\log_a x = \\frac{\\log_b x}{\\log_b a}"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P2",
        "title": "Binomial series",
        "formula": [
            "(a + b)^n = a^n + \\binom{n}{1} a^{n-1}b + \\binom{n}{2} a^{n-2}b^2 + ... + \\binom{n}{r} a^{n-r}b^r + ... + b^n \\quad (n \\in \\mathbb{N})",
            "\\binom{n}{r} = \\frac{n!}{r!(n - r)!} = {}_nC_r",
            "(1 + x)^n = 1 + nx + \\frac{n(n - 1)}{1 \\times 2} x^2 + \\frac{n(n - 1)(n - 2)}{1 \\times 2 \\times 3} x^3 + ... \\quad (|x| < 1, n \\in \\mathbb{R})"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P2",
        "title": "Numerical integration",
        "formula": [
            "\\int_a^b y \\, dx \\approx \\frac{1}{2} h (y_0 + y_n) + 2(y_1 + y_2 + ... + y_{n-1}), \\quad \\text{where } h = \\frac{b - a}{n}"
        ]
    },

    {
        "level": " EDEXCEL Pure Mathematics P3",
        "title": "Logarithms and exponentials",
        "formula": [
            "e^{\\ln a} = a^x"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P3",
        "title": "Trigonometric identities",
        "formula": [
            "\\sin(A \\pm B) \\equiv \\sin A \\cos B \\pm \\cos A \\sin B",
            "\\cos(A \\pm B) \\equiv \\cos A \\cos B \\mp \\sin A \\sin B",
            "\\tan(A \\pm B) \\equiv \\frac{\\tan A \\pm \\tan B}{1 \\mp \\tan A \\tan B} \\quad \\left(A \\pm B \\neq \\left(k + \\frac{1}{2}\\right) \\pi \\right)",
            "\\sin A + \\sin B \\equiv 2 \\sin \\frac{A + B}{2} \\cos \\frac{A - B}{2}",
            "\\sin A - \\sin B \\equiv 2 \\cos \\frac{A + B}{2} \\sin \\frac{A - B}{2}",
            "\\cos A + \\cos B \\equiv 2 \\cos \\frac{A + B}{2} \\cos \\frac{A - B}{2}",
            "\\cos A - \\cos B \\equiv -2 \\sin \\frac{A + B}{2} \\sin \\frac{A - B}{2}"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P3",
        "title": "Differentiation",
        "formula": [
            "\\frac{d}{dx} \\tan kx = k \\sec^2 kx",
            "\\frac{d}{dx} \\sec x = \\sec x \\tan x",
            "\\frac{d}{dx} \\cot x = -\\csc^2 x",
            "\\frac{d}{dx} \\csc x = -\\csc x \\cot x",
            "\\frac{d}{dx} \\frac{f(x)}{g(x)} = \\frac{f'(x) g(x) - f(x) g'(x)}{(g(x))^2}"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P3",
        "title": "Integration (+ constant)",
        "formula": [
            "\\int \\sec^2 kx \\, dx = \\frac{1}{k} \\tan kx",
            "\\int \\tan x \\, dx = \\ln |\\sec x|",
            "\\int \\cot x \\, dx = \\ln |\\sin x|"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P4",
        "title": "Binomial series",
        "formula": [
            "(1 + x)^n = 1 + nx + \\frac{n(n - 1)}{1 \\times 2} x^2 + ... + \\frac{n(n - 1)...(n - r + 1)}{1 \\times 2 \\times ... \\times r} x^r + ... \\quad (|x| < 1, n \\in \\mathbb{R})"
        ]
    },
    {
        "level": " EDEXCEL Pure Mathematics P4",
        "title": "Integration (+ constant)",
        "formula": [
            "\\int \\csc x \\, dx = - \\ln |\\csc x + \\cot x|, \\quad \\ln \\left| \\tan \\left( \\frac{1}{2} x \\right) \\right|",
            "\\int \\sec x \\, dx = \\ln |\\sec x + \\tan x|, \\quad \\ln \\left| \\tan \\left( \\frac{1}{2} x + \\frac{1}{4} \\pi \\right) \\right|",
            "\\int \\frac{du}{dx} \\, dx = uv - \\int v \\frac{du}{dx} \\, dx"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP1",
        "title": "Summations",
        "formula": [
            "\\sum_{r=1}^{n} r^2 = \\frac{1}{6} n(n + 1)(2n + 1)",
            "\\sum_{r=1}^{n} r^3 = \\frac{1}{4} n^2(n + 1)^2"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP1",
        "title": "Numerical solution of equations",
        "formula": [
            "\\text{The Newton-Raphson iteration for solving } f(x) = 0: \\quad x_{n+1} = x_n - \\frac{f(x_n)}{f'(x_n)}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP1",
        "title": "Conics",
        "formula": [
            "\\begin{array}{|c|c|} \\hline \\textbf{Parabola} & \\textbf{Rectangular Hyperbola} \\\\ \\hline y^2 = 4ax & xy = c^2 \\\\ \\hline (at^2, 2at) & \\left( ct, \\frac{c}{t} \\right) \\\\ \\hline (a, 0) & \\text{Not required} \\\\ \\hline x = -a & \\text{Not required} \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP1",
        "title": "Matrix transformations",
        "formula": [
            "\\text{Anticlockwise rotation through } \\theta \\text{ about } O: \\quad \\begin{bmatrix} \\cos \\theta & -\\sin \\theta \\\\ \\sin \\theta & \\cos \\theta \\end{bmatrix}",
            "\\text{Reflection in the line } y = (\\tan \\theta)x: \\quad \\begin{bmatrix} \\cos 2\\theta & \\sin 2\\theta \\\\ \\sin 2\\theta & -\\cos 2\\theta \\end{bmatrix}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP2",
        "title": "Area of a sector",
        "formula": [
            "A = \\frac{1}{2} \\int r^2 \\, d\\theta \\quad \\text{(polar coordinates)}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP2",
        "title": "Complex numbers",
        "formula": [
            "e^{i\\theta} = \\cos \\theta + i \\sin \\theta",
            "\\{r (\\cos \\theta + i \\sin \\theta)\\}^n = r^n (\\cos n\\theta + i \\sin n\\theta)",
            "\\text{The roots of } z^n = 1 \\text{ are given by } z = e^{\\frac{2 \\pi i k}{n}}, \\text{ for } k = 0, 1, 2, \\dots, n - 1"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP2",
        "title": "Maclaurin’s and Taylor’s Series",
        "formula": [
            "f(x) = f(0) + x f'(0) + \\frac{x^2}{2!} f''(0) + \\dots + \\frac{x^r}{r!} f^{(r)}(0) + \\dots",
            "f(x) = f(a) + (x - a) f'(a) + \\frac{(x - a)^2}{2!} f''(a) + \\dots + \\frac{(x - a)^r}{r!} f^{(r)}(a) + \\dots",
            "e^x = \\sum_{r=0}^{\\infty} \\frac{x^r}{r!}, \\quad \\text{for all } x",
            "\\ln(1 + x) = x - \\frac{x^2}{2} + \\frac{x^3}{3} - \\dots + (-1)^{r+1} \\frac{x^r}{r}, \\quad (-1 < x \\leq 1)",
            "\\sin x = x - \\frac{x^3}{3!} + \\frac{x^5}{5!} - \\dots + (-1)^r \\frac{x^{2r+1}}{(2r+1)!}, \\quad \\text{for all } x",
            "\\cos x = 1 - \\frac{x^2}{2!} + \\frac{x^4}{4!} - \\dots + (-1)^r \\frac{x^{2r}}{(2r)!}, \\quad \\text{for all } x",
            "\\arctan x = x - \\frac{x^3}{3} + \\frac{x^5}{5} - \\dots + (-1)^r \\frac{x^{2r+1}}{2r+1}, \\quad (-1 \\leq x \\leq 1)"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Vectors",
        "formula": [
            "\\text{The resolved part of } \\mathbf{a} \\text{ in the direction of } \\mathbf{b} \\text{ is } \\frac{\\mathbf{a} \\cdot \\mathbf{b}}{|\\mathbf{b}|}",
            "\\text{The point dividing } AB \\text{ in the ratio } \\lambda : \\mu \\text{ is } \\mu \\frac{a + \\lambda b}{\\lambda + \\mu}",
            "\\text{Vector product: } \\mathbf{a} \\times \\mathbf{b} = |\\mathbf{a}| |\\mathbf{b}| \\sin \\theta \\mathbf{n}",
            "\\begin{vmatrix} i & j & k \\\\ a_1 & a_2 & a_3 \\\\ b_1 & b_2 & b_3 \\end{vmatrix} = \\begin{bmatrix} a_2 b_3 - a_3 b_2 \\\\ a_3 b_1 - a_1 b_3 \\\\ a_1 b_2 - a_2 b_1 \\end{bmatrix}",
            "\\mathbf{a} \\cdot (\\mathbf{b} \\times \\mathbf{c}) = \\begin{vmatrix} a_1 & a_2 & a_3 \\\\ b_1 & b_2 & b_3 \\\\ c_1 & c_2 & c_3 \\end{vmatrix} = \\mathbf{b} \\cdot (\\mathbf{c} \\times \\mathbf{a}) = \\mathbf{c} \\cdot (\\mathbf{a} \\times \\mathbf{b})",
            "\\text{If } A \\text{ is the point with position vector } \\mathbf{a} = a_1 \\mathbf{i} + a_2 \\mathbf{j} + a_3 \\mathbf{k} \\\\ \\text{ and the direction vector } \\mathbf{b} \\text{ is given by } \\mathbf{b} = b_1 \\mathbf{i} + b_2 \\mathbf{j} + b_3 \\mathbf{k} \\\\ \\text{ then the straight line through } A \\text{ with direction vector } \\mathbf{b} \\text{ has cartesian equation } \\\\ \\frac{x - a_1}{b_1} = \\frac{y - a_2}{b_2} = \\frac{z - a_3}{b_3} = \\lambda",
            "\\text{The plane through } A \\text{ with normal vector } \\mathbf{n} = n_1 \\mathbf{i} + n_2 \\mathbf{j} + n_3 \\mathbf{k} \\\\ \\text{ has cartesian equation } n_1 x + n_2 y + n_3 z + d = 0 \\text{ where } d = - \\mathbf{a} \\cdot \\mathbf{n}",
            "\\text{The plane through non-collinear points } A, B, C \\text{ has vector equation } \\\\ \\mathbf{r} = \\mathbf{a} + \\lambda (\\mathbf{b} - \\mathbf{a}) + \\mu (\\mathbf{c} - \\mathbf{a}) = (1 - \\lambda - \\mu) \\mathbf{a} + \\lambda \\mathbf{b} + \\mu \\mathbf{c}",
            "\\text{The plane through the point with position vector } \\mathbf{a} \\\\ \\text{ and parallel to } \\mathbf{b} \\text{ and } \\mathbf{c} \\text{ has equation } \\mathbf{r} = \\mathbf{a} + s \\mathbf{b} + t \\mathbf{c}",
            "\\text{The perpendicular distance of } (\\alpha, \\beta, \\gamma) \\text{ from } n_1 x + n_2 y + n_3 z + d = 0 \\text{ is } \\\\ \\frac{|n_1 \\alpha + n_2 \\beta + n_3 \\gamma + d|}{\\sqrt{n_1^2 + n_2^2 + n_3^2}}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Hyperbolic functions",
        "formula": [
            "\\cosh^2 x - \\sinh^2 x = 1",
            "\\sinh 2x = 2 \\sinh x \\cosh x",
            "\\cosh 2x = \\cosh^2 x + \\sinh^2 x",
            "\\text{arcosh } x = \\ln \\{ x + \\sqrt{x^2 - 1} \\} \\quad (x \\geq 1)",
            "\\text{arsinh } x = \\ln \\{ x + \\sqrt{x^2 + 1} \\}",
            "\\text{artanh } x = \\frac{1}{2} \\ln \\left( \\frac{1 + x}{1 - x} \\right) \\quad (|x| < 1)"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Conics",
        "formula": [
            "\\begin{array}{|c|c|c|c|c|} \\hline \\textbf{Property} & \\textbf{Ellipse} & \\textbf{Parabola} & \\textbf{Hyperbola} & \\textbf{Rectangular Hyperbola} \\\\ \\hline \\text{Standard Form} & \\frac{x^2}{a^2} + \\frac{y^2}{b^2} = 1 & y^2 = 4ax & \\frac{x^2}{a^2} - \\frac{y^2}{b^2} = 1 & xy = c^2 \\\\ \\hline \\text{Parametric Form} & (a \\cos \\theta, b \\sin \\theta) & (at^2, 2at) & (a \\sec \\theta, b \\tan \\theta), (\\pm a \\cosh \\theta, b \\sinh \\theta) & \\left( ct, \\frac{c}{t} \\right) \\\\ \\hline \\text{Eccentricity} & e < 1, \\quad b^2 = a^2 (1 - e^2) & e = 1 & e > 1, \\quad b^2 = a^2 (e^2 - 1) & e = \\sqrt{2} \\\\ \\hline \\text{Foci} & (\\pm ae, 0) & (a, 0) & (\\pm ae, 0) & (\\pm \\sqrt{2} c, \\pm \\sqrt{2} c) \\\\ \\hline \\text{Directrices} & x = \\pm \\frac{a}{e} & x = -a & x = \\pm \\frac{a}{e} & x + y = \\pm \\sqrt{2} c \\\\ \\hline \\text{Asymptotes} & \\text{none} & \\text{none} & \\frac{x}{a} = \\pm \\frac{y}{b} & x = 0, y = 0 \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Differentiation",
        "formula": [
            "\\frac{d}{dx} \\arcsin x = \\frac{1}{\\sqrt{1 - x^2}}",
            "\\frac{d}{dx} \\arccos x = \\frac{-1}{\\sqrt{1 - x^2}}",
            "\\frac{d}{dx} \\arctan x = \\frac{1}{1 + x^2}",
            "\\frac{d}{dx} \\sinh x = \\cosh x",
            "\\frac{d}{dx} \\cosh x = \\sinh x",
            "\\frac{d}{dx} \\tanh x = \\text{sech}^2 x",
            "\\frac{d}{dx} \\text{arsinh} x = \\frac{1}{\\sqrt{1 + x^2}}",
            "\\frac{d}{dx} \\text{arcosh} x = \\frac{1}{\\sqrt{x^2 - 1}}",
            "\\frac{d}{dx} \\text{artanh} x = \\frac{1}{1 - x^2}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Integration (+ constant; } a > 0 \\text{ where relevant})",
        "formula": [
            "\\int \\sinh x \\, dx = \\cosh x",
            "\\int \\cosh x \\, dx = \\sinh x",
            "\\int \\tanh x \\, dx = \\ln \\cosh x",
            "\\int \\frac{1}{\\sqrt{a^2 - x^2}} \\, dx = \\arcsin \\left( \\frac{x}{a} \\right) \\quad (|x| < a)",
            "\\int \\frac{1}{a^2 + x^2} \\, dx = \\frac{1}{a} \\arctan \\left( \\frac{x}{a} \\right)",
            "\\int \\frac{1}{\\sqrt{x^2 - a^2}} \\, dx = \\text{arcosh} \\left( \\frac{x}{a} \\right), \\quad \\ln \\{ x + \\sqrt{x^2 - a^2} \\} \\quad (x > a)",
            "\\int \\frac{1}{\\sqrt{x^2 + a^2}} \\, dx = \\text{arsinh} \\left( \\frac{x}{a} \\right), \\quad \\ln \\{ x + \\sqrt{x^2 + a^2} \\}",
            "\\int \\frac{1}{a^2 - x^2} \\, dx = \\frac{1}{2a} \\ln \\left| \\frac{a + x}{a - x} \\right| = \\frac{1}{a} \\text{artanh} \\left( \\frac{x}{a} \\right) \\quad (|x| < a)",
            "\\int \\frac{1}{2a} \\ln \\left| \\frac{x - a}{x + a} \\right| \\, dx"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Arc length",
        "formula": [
            "s = \\int \\sqrt{1 + \\left( \\frac{dy}{dx} \\right)^2} \\, dx \\quad \\text{(cartesian coordinates)}",
            "s = \\int \\sqrt{\\left( \\frac{dx}{dt} \\right)^2 + \\left( \\frac{dy}{dt} \\right)^2} \\, dt \\quad \\text{(parametric form)}"
        ]
    },
    {
        "level": " EDEXCEL Further Pure Mathematics FP3",
        "title": "Surface area of revolution",
        "formula": [
            "S_x = 2\\pi \\int y \\, ds = 2\\pi \\int y \\sqrt{1 + \\left( \\frac{dy}{dx} \\right)^2} \\, dx",
            "= 2\\pi \\int y \\sqrt{\\left( \\frac{dx}{dt} \\right)^2 + \\left( \\frac{dy}{dt} \\right)^2} \\, dt"
        ]
    },
    {
        "level": " EDEXCEL Mechanics M2",
        "title": "Centres of mass",
        "formula": [
            "\\text{For uniform bodies:}",
            "\\text{Triangular lamina: } \\frac{2}{3} \\text{ along median from vertex}",
            "\\text{Circular arc, radius } r, \\text{ angle at centre } 2a: \\quad \\frac{r \\sin a}{a} \\text{ from centre}",
            "\\text{Sector of circle, radius } r, \\text{ angle at centre } 2a: \\quad \\frac{2r \\sin a}{3a} \\text{ from centre}"
        ]
    },
    {
        "level": " EDEXCEL Mechanics M3",
        "title": "Motion in a circle",
        "formula": [
            "\\text{Transverse velocity: } v = r \\dot{\\theta}",
            "\\text{Transverse acceleration: } \\dot{v} = r \\ddot{\\theta}",
            "\\text{Radial acceleration: } -r \\ddot{\\theta} = \\frac{v^2}{r}"
        ]
    },
    {
        "level": " EDEXCEL Mechanics M3",
        "title": "Centres of mass",
        "formula": [
            "\\text{For uniform bodies:}",
            "\\text{Solid hemisphere, radius } r: \\quad \\frac{3}{8} r \\text{ from centre}",
            "\\text{Hemispherical shell, radius } r: \\quad \\frac{1}{2} r \\text{ from centre}",
            "\\text{Solid cone or pyramid of height } h: \\quad \\frac{1}{4} h \\text{ above the base on the line from centre of base to vertex}",
            "\\text{Conical shell of height } h: \\quad \\frac{1}{3} h \\text{ above the base on the line from centre of base to vertex}"
        ]
    },
    {
        "level": " EDEXCEL Mechanics M3",
        "title": "Universal law of gravitation",
        "formula": [
            "\\text{Force } = \\frac{G m_1 m_2}{d^2}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S1",
        "title": "Probability",
        "formula": [
            "P(A \\cup B) = P(A) + P(B) - P(A \\cap B)",
            "P(A \\cap B) = P(A) P(B | A)",
            "P(A | B) = \\frac{P(B | A) P(A)}{P(B | A) P(A) + P(B | A') P(A')}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S1",
        "title": "Discrete distributions",
        "formula": [
            "\\text{For a discrete random variable } X \\text{ taking values } x_i, \\text{ with probabilities } P(X = x_i):",
            "\\text{Expectation (mean): } E(X) = \\mu = \\sum x_i P(X = x_i)",
            "\\text{Variance: } \\text{Var}(X) = \\sigma^2 = \\sum (x_i - \\mu)^2 P(X = x_i) = \\sum x_i^2 P(X = x_i) - \\mu^2",
            "\\text{For a function } g(X): \\quad E(g(X)) = \\sum g(x_i) P(X = x_i)"
        ]
    },
    {
        "level": " EDEXCEL Statistics S1",
        "title": "Continuous distributions",
        "formula": [
            "\\begin{array}{|c|c|c|c|} \\hline \\textbf{Distribution of } X & \\textbf{P.D.F.} & \\textbf{Mean} & \\textbf{Variance} \\\\ \\hline \\text{Normal } N(\\mu, \\sigma^2) & \\frac{1}{\\sigma \\sqrt{2\\pi}} e^{-\\frac{(x - \\mu)^2}{2\\sigma^2}} & \\mu & \\sigma^2 \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S1",
        "title": "Correlation and regression",
        "formula": [
            "\\text{For a set of } n \\text{ pairs of values } (x_i, y_i):",
            "S_{xx} = \\sum (x_i - \\bar{x})^2 = \\sum x_i^2 - \\frac{(\\sum x_i)^2}{n}",
            "S_{yy} = \\sum (y_i - \\bar{y})^2 = \\sum y_i^2 - \\frac{(\\sum y_i)^2}{n}",
            "S_{xy} = \\sum (x_i - \\bar{x})(y_i - \\bar{y}) = \\sum x_i y_i - \\frac{(\\sum x_i)(\\sum y_i)}{n}",
            "\\text{The product moment correlation coefficient is }",
            "r = \\frac{S_{xy}}{\\sqrt{S_{xx} S_{yy}}} = \\frac{\\sum x_i y_i - \\frac{(\\sum x_i)(\\sum y_i)}{n}}{\\sqrt{\\left( \\sum x_i^2 - \\frac{(\\sum x_i)^2}{n} \\right) \\left( \\sum y_i^2 - \\frac{(\\sum y_i)^2}{n} \\right)}}",
            "\\text{The regression coefficient of } y \\text{ on } x \\text{ is } b = \\frac{S_{xy}}{S_{xx}} = \\frac{\\sum (x_i - \\bar{x})(y_i - \\bar{y})}{\\sum (x_i - \\bar{x})^2}",
            "\\text{Least squares regression line of } y \\text{ on } x \\text{ is } y = a + bx \\text{ where } a = \\bar{y} - b \\bar{x}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S1",
        "title": "Percentage Points of the Normal Distribution",
        "formula": [
            "\\text{The values } z \\text{ in the table are those which a random variable } Z \\sim N(0,1) \\text{ exceeds with probability } p, \\text{ that is, } P(Z > z) = 1 - \\Phi(z) = p.",
            "\\begin{array}{|c|c||c|c|} \\hline p & z & p & z \\\\ \\hline 0.5000 & 0.0000 & 0.0500 & 1.6449 \\\\ 0.4000 & 0.2533 & 0.0250 & 1.9600 \\\\ 0.3000 & 0.5244 & 0.0100 & 2.3263 \\\\ 0.2000 & 0.8416 & 0.0050 & 2.5758 \\\\ 0.1500 & 1.0364 & 0.0010 & 3.0902 \\\\ 0.1000 & 1.2816 & 0.0005 & 3.2905 \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S2",
        "title": "Discrete distributions",
        "formula": [
            "\\text{Standard discrete distributions:}",
            "\\begin{array}{|c|c|c|c|} \\hline \\text{Distribution of } X & P(X = x) & \\text{Mean} & \\text{Variance} \\\\ \\hline \\text{Binomial } B(n, p) & \\binom{n}{x} p^x (1 - p)^{n - x} & np & np(1 - p) \\\\ \\hline \\text{Poisson } Po(\\lambda) & \\frac{e^{-\\lambda} \\lambda^x}{x!} & \\lambda & \\lambda \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S2",
        "title": "Continuous distributions",
        "formula": [
            "\\text{For a continuous random variable } X \\text{ having probability density function } f,",
            "\\text{Expectation (mean): } E(X) = \\mu = \\int x f(x) \\, dx",
            "\\text{Variance: } \\operatorname{Var}(X) = \\sigma^2 = \\int (x - \\mu)^2 f(x) \\, dx = \\int x^2 f(x) \\, dx - \\mu^2",
            "\\text{For a function } g(X): \\quad E(g(X)) = \\int g(x) f(x) \\, dx",
            "\\text{Cumulative distribution function: } F(x_0) = P(X \\leq x_0) = \\int_{-\\infty}^{x_0} f(t) \\, dt"
        ]
    },
    {
        "level": " EDEXCEL Statistics S2",
        "title": "Standard continuous distribution",
        "formula": [
            "\\begin{array}{|c|c|c|c|} \\hline \\text{Distribution of } X & \\text{P.D.F.} & \\text{Mean} & \\text{Variance} \\\\ \\hline \\text{Uniform (Rectangular) on } [a, b] & \\frac{1}{b - a} & \\frac{1}{2} (a + b) & \\frac{1}{12} (b - a)^2 \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S3",
        "title": "Expectation algebra",
        "formula": [
            "\\text{For independent random variables } X \\text{ and } Y,",
            "E(XY) = E(X)E(Y), \\quad \\operatorname{Var}(aX \\pm bY) = a^2 \\operatorname{Var}(X) + b^2 \\operatorname{Var}(Y)"
        ]
    },
    {
        "level": " EDEXCEL Statistics S3",
        "title": "Sampling distributions",
        "formula": [
            "\\text{For a random sample } X_1, X_2, \\dots, X_n \\text{ of } n \\text{ independent observations from a distribution having mean } \\mu \\text{ and variance } \\sigma^2,",
            "\\bar{X} \\text{ is an unbiased estimator of } \\mu \\text{, with } \\operatorname{Var}(\\bar{X}) = \\frac{\\sigma^2}{n}",
            "S^2 \\text{ is an unbiased estimator of } \\sigma^2, \\text{ where } S^2 = \\frac{\\sum (X_i - \\bar{X})^2}{n - 1}",
            "\\text{For a random sample of } n \\text{ observations from } N(\\mu, \\sigma^2),",
            "\\frac{\\bar{X} - \\mu}{\\sigma / \\sqrt{n}} \\sim N(0, 1)",
            "\\text{For a random sample of } n_x \\text{ observations from } N(\\mu_x, \\sigma_x^2) \\text{ and, independently, a random sample of } n_y \\text{ observations from } N(\\mu_y, \\sigma_y^2),",
            "\\frac{(\\bar{X} - \\bar{Y}) - (\\mu_x - \\mu_y)}{\\sqrt{\\frac{\\sigma_x^2}{n_x} + \\frac{\\sigma_y^2}{n_y}}} \\sim N(0, 1)"
        ]
    },
    {
        "level": " EDEXCEL Statistics S3",
        "title": "Correlation and regression",
        "formula": [
            "\\text{Spearman’s rank correlation coefficient is } r, \\quad r = 1 - \\frac{6 \\sum d^2}{n(n^2 - 1)}"
        ]
    },
    {
        "level": " EDEXCEL Statistics S3",
        "title": "Non-parametric tests",
        "formula": [
            "\\text{Goodness-of-fit test and contingency tables: } \\sum \\frac{(O_i - E_i)^2}{E_i} \\sim \\chi^2_r"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Mensuration",
        "formula": [
            "\\text{Volume of sphere} = \\frac{4}{3} \\pi r^3",
            "\\text{Surface area of sphere} = 4 \\pi r^2",
            "\\text{Volume of cone or pyramid} = \\frac{1}{3} \\times \\text{base area} \\times \\text{height}",
            "\\text{Area of curved surface of cone} = \\pi r \\times \\text{slant height}",
            "\\text{Arc length of circle} = r \\theta \\quad (\\theta \\text{ in radians})",
            "\\text{Area of sector of circle} = \\frac{1}{2} r^2 \\theta \\quad (\\theta \\text{ in radians})"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Algebra",
        "formula": [
            "\\text{For the quadratic equation } ax^2 + bx + c = 0:",
            "x = \\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}",
            "\\text{For an arithmetic series: }",
            "u_n = a + (n - 1) d, \\quad S_n = \\frac{1}{2} n (a + l) = \\frac{1}{2} n \\{2a + (n - 1) d\\}",
            "\\text{For a geometric series: }",
            "u_n = ar^{n-1}, \\quad S_n = \\frac{a(1 - r^n)}{1 - r} \\quad (r \\neq 1), \\quad S_\\infty = \\frac{a}{1 - r} \\quad (|r| < 1)",
            "\\text{Binomial series: }",
            "(a + b)^n = a^n + \\binom{n}{1} a^{n-1} b + \\binom{n}{2} a^{n-2} b^2 + \\binom{n}{3} a^{n-3} b^3 + \\dots + b^n, \\quad \\text{where } n \\text{ is a positive integer}",
            "\\binom{n}{r} = \\frac{n!}{r!(n - r)!}",
            "(1 + x)^n = 1 + nx + \\frac{n(n - 1)}{2!} x^2 + \\frac{n(n - 1)(n - 2)}{3!} x^3 + \\dots, \\quad \\text{where } n \\text{ is rational and } |x| < 1"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Trigonometry",
        "formula": [
            "\\tan \\theta \\equiv \\frac{\\sin \\theta}{\\cos \\theta}",
            "\\cos^2 \\theta + \\sin^2 \\theta \\equiv 1,",
            "1 + \\tan^2 \\theta \\equiv \\sec^2 \\theta,",
            "\\cot^2 \\theta + 1 \\equiv \\cosec^2 \\theta",
            "\\sin (A \\pm B) \\equiv \\sin A \\cos B \\pm \\cos A \\sin B",
            "\\cos (A \\pm B) \\equiv \\cos A \\cos B \\mp \\sin A \\sin B",
            "\\tan (A \\pm B) \\equiv \\frac{\\tan A \\pm \\tan B}{1 \\mp \\tan A \\tan B}",
            "\\sin 2A \\equiv 2 \\sin A \\cos A",
            "\\cos 2A \\equiv \\cos^2 A - \\sin^2 A \\equiv 2 \\cos^2 A - 1 \\equiv 1 - 2 \\sin^2 A",
            "\\tan 2A \\equiv \\frac{2 \\tan A}{1 - \\tan^2 A}",
            "\\text{Principal values: }",
            "-\\frac{1}{2} \\pi < \\sin^{-1} x < \\frac{1}{2} \\pi, \\quad 0 < \\cos^{-1} x < \\pi, \\quad -\\frac{1}{2} \\pi < \\tan^{-1} x < \\frac{1}{2} \\pi"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Differentiation",
        "formula": [
            "\\begin{array}{|c|c|} \\hline f(x) & f'(x) \\\\ \\hline x^n & n x^{n-1} \\\\ \\ln x & \\frac{1}{x} \\\\ e^x & e^x \\\\ \\sin x & \\cos x \\\\ \\cos x & -\\sin x \\\\ \\tan x & \\sec^2 x \\\\ \\sec x & \\sec x \\tan x \\\\ \\cosec x & -\\cosec x \\cot x \\\\ \\cot x & -\\cosec^2 x \\\\ \\tan^{-1} x & \\frac{1}{1 + x^2} \\\\ uv & v \\frac{du}{dx} + u \\frac{dv}{dx} \\\\ \\frac{u}{v} & \\frac{v \\frac{du}{dx} - u \\frac{dv}{dx}}{v^2} \\\\ \\hline \\end{array}",
            "\\text{If } x = f(t) \\text{ and } y = g(t) \\text{ then } \\frac{dy}{dx} = \\frac{dy}{dt} \\div \\frac{dx}{dt}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Integration",
        "formula": [
            "\\begin{array}{|c|c|} \\hline f(x) & \\int f(x) \\, dx \\\\ \\hline x^n & \\frac{x^{n+1}}{n+1} \\quad (n \\neq -1) \\\\ \\frac{1}{x} & \\ln |x| \\\\ e^x & e^x \\\\ \\sin x & -\\cos x \\\\ \\cos x & \\sin x \\\\ \\sec^2 x & \\tan x \\\\ \\frac{1}{x^2 + a^2} & \\frac{1}{a} \\tan^{-1} \\left( \\frac{x}{a} \\right) \\\\ \\frac{1}{x^2 - a^2} & \\frac{1}{2a} \\ln \\left| \\frac{x - a}{x + a} \\right| \\quad (x > a) \\\\ \\frac{1}{a^2 - x^2} & \\frac{1}{2a} \\ln \\left| \\frac{a + x}{a - x} \\right| \\quad (|x| < a) \\\\ \\hline \\end{array}",
            "\\int u \\frac{dv}{dx} \\, dx = uv - \\int v \\frac{du}{dx} \\, dx",
            "\\int \\frac{f'(x)}{f(x)} \\, dx = \\ln |f(x)|"
        ]
    },
    {
        "level": "CAIE LIST MF19 Pure Mathematics",
        "title": "Vectors",
        "formula": [
            "\\text{If } \\mathbf{a} = a_1 \\mathbf{i} + a_2 \\mathbf{j} + a_3 \\mathbf{k} \\text{ and } \\mathbf{b} = b_1 \\mathbf{i} + b_2 \\mathbf{j} + b_3 \\mathbf{k} \\text{ then}",
            "\\mathbf{a} \\cdot \\mathbf{b} = a_1 b_1 + a_2 b_2 + a_3 b_3 = |\\mathbf{a}| |\\mathbf{b}| \\cos \\theta"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Summations",
        "formula": [
            "\\sum_{r=1}^{n} r = \\frac{1}{2} n (n + 1), \\quad \\sum_{r=1}^{n} r^2 = \\frac{1}{6} n (n + 1)(2n + 1), \\quad \\sum_{r=1}^{n} r^3 = \\frac{1}{4} n^2 (n + 1)^2"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Maclaurin’s series",
        "formula": [
            "f(x) = f(0) + x f'(0) + \\frac{x^2}{2!} f''(0) + \\dots + \\frac{x^r}{r!} f^{(r)}(0) + \\dots",
            "e^x = \\operatorname{exp}(x) = 1 + x + \\frac{x^2}{2!} + \\dots + \\frac{x^r}{r!} + \\dots \\quad \\text{(all } x \\text{)}",
            "\\ln(1 + x) = x - \\frac{x^2}{2} + \\frac{x^3}{3} - \\dots + (-1)^{r+1} \\frac{x^r}{r} + \\dots \\quad (-1 < x < 1)",
            "\\sin x = x - \\frac{x^3}{3!} + \\frac{x^5}{5!} - \\dots + (-1)^r \\frac{x^{2r+1}}{(2r+1)!} + \\dots \\quad \\text{(all } x \\text{)}",
            "\\cos x = 1 - \\frac{x^2}{2!} + \\frac{x^4}{4!} - \\dots + (-1)^r \\frac{x^{2r}}{(2r)!} + \\dots \\quad \\text{(all } x \\text{)}",
            "\\tan^{-1} x = x - \\frac{x^3}{3} + \\frac{x^5}{5} - \\dots + (-1)^r \\frac{x^{2r+1}}{2r+1} + \\dots \\quad (-1 < x < 1)",
            "\\sinh x = x + \\frac{x^3}{3!} + \\frac{x^5}{5!} + \\dots + \\frac{x^{2r+1}}{(2r+1)!} + \\dots \\quad \\text{(all } x \\text{)}",
            "\\cosh x = 1 + \\frac{x^2}{2!} + \\frac{x^4}{4!} + \\dots + \\frac{x^{2r}}{(2r)!} + \\dots \\quad \\text{(all } x \\text{)}",
            "\\tanh^{-1} x = x + \\frac{x^3}{3} + \\frac{x^5}{5} + \\dots + \\frac{x^{2r+1}}{2r+1} + \\dots \\quad (-1 < x < 1)"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Trigonometry",
        "formula": [
            "\\text{If } t = \\tan \\frac{1}{2} x \\text{ then:}",
            "\\sin x = \\frac{2t}{1 + t^2} \\quad \\text{and} \\quad \\cos x = \\frac{1 - t^2}{1 + t^2}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Hyperbolic functions",
        "formula": [
            "\\cosh^2 x - \\sinh^2 x \\equiv 1,",
            "\\sinh 2x \\equiv 2 \\sinh x \\cosh x,",
            "\\cosh 2x \\equiv \\cosh^2 x + \\sinh^2 x",
            "\\sinh^{-1} x = \\ln(x + \\sqrt{x^2 + 1})",
            "\\cosh^{-1} x = \\ln(x + \\sqrt{x^2 - 1}) \\quad (x \\geq 1)",
            "\\tanh^{-1} x = \\frac{1}{2} \\ln \\left( \\frac{1 + x}{1 - x} \\right) \\quad (|x| < 1)"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Differentiation",
        "formula": [
            "\\begin{array}{|c|c|} \\hline f(x) & f'(x) \\\\ \\hline \\sin^{-1} x & \\frac{1}{\\sqrt{1 - x^2}} \\\\ \\cos^{-1} x & -\\frac{1}{\\sqrt{1 - x^2}} \\\\ \\sinh x & \\cosh x \\\\ \\cosh x & \\sinh x \\\\ \\tanh x & \\operatorname{sech}^2 x \\\\ \\sinh^{-1} x & \\frac{1}{\\sqrt{1 + x^2}} \\\\ \\cosh^{-1} x & \\frac{1}{\\sqrt{x^2 - 1}} \\\\ \\tanh^{-1} x & \\frac{1}{1 - x^2} \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Pure Mathematics",
        "title": "Integration",
        "formula": [
            "\\begin{array}{|c|c|} \\hline f(x) & \\int f(x) \\, dx \\\\ \\hline \\sec x & \\ln | \\sec x + \\tan x | = \\ln | \\tan ( \\frac{1}{2} x + \\frac{1}{4} \\pi ) | \\quad (|x| < \\frac{1}{2} \\pi) \\\\ \\cosec x & -\\ln | \\cosec x + \\cot x | = \\ln | \\tan ( \\frac{1}{2} x ) | \\quad (0 < x < \\pi) \\\\ \\sinh x & \\cosh x \\\\ \\cosh x & \\sinh x \\\\ \\operatorname{sech}^2 x & \\tanh x \\\\ \\frac{1}{\\sqrt{a^2 - x^2}} & \\sin^{-1} \\left( \\frac{x}{a} \\right) \\quad (|x| < a) \\\\ \\frac{1}{\\sqrt{x^2 - a^2}} & \\cosh^{-1} \\left( \\frac{x}{a} \\right) \\quad (x > a) \\\\ \\frac{1}{\\sqrt{a^2 + x^2}} & \\sinh^{-1} \\left( \\frac{x}{a} \\right) \\\\ \\hline \\end{array}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Mechanics",
        "title": "Uniformly accelerated motion",
        "formula": [
            "v = u + at, \\quad s = \\frac{1}{2} (u + v) t, \\quad s = ut + \\frac{1}{2} at^2, \\quad v^2 = u^2 + 2as"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Mechanics",
        "title": "Motion of a projectile",
        "formula": [
            "\\text{Equation of trajectory:} \\quad y = x \\tan \\theta - \\frac{g x^2}{2V^2 \\cos^2 \\theta}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Mechanics",
        "title": "Elastic strings and springs",
        "formula": [
            "T = \\frac{\\lambda x}{l}, \\quad E = \\frac{\\lambda x^2}{2l}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Mechanics",
        "title": "Motion in a circle",
        "formula": [
            "\\text{For uniform circular motion, the acceleration is directed towards the centre and has magnitude:}",
            "\\omega^2 r \\quad \\text{or} \\quad \\frac{v^2}{r}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Mechanics",
        "title": "Centres of mass of uniform bodies",
        "formula": [
            "\\text{Triangular lamina: } \\frac{2}{3} \\text{ along median from vertex}",
            "\\text{Solid hemisphere of radius } r: \\quad \\frac{3}{8} r \\text{ from centre}",
            "\\text{Hemispherical shell of radius } r: \\quad \\frac{1}{2} r \\text{ from centre}",
            "\\text{Circular arc of radius } r \\text{ and angle } 2\\alpha: \\quad \\frac{r \\sin \\alpha}{\\alpha} \\text{ from centre}",
            "\\text{Circular sector of radius } r \\text{ and angle } 2\\alpha: \\quad \\frac{2r \\sin \\alpha}{3\\alpha} \\text{ from centre}",
            "\\text{Solid cone or pyramid of height } h: \\quad \\frac{3}{4} h \\text{ from vertex}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Probability & Statistics",
        "title": "Summary statistics",
        "formula": [
            "\\text{For ungrouped data:} \\quad \\bar{x} = \\frac{\\sum x}{n}, \\quad \\text{standard deviation} = \\sqrt{\\frac{\\sum (x - \\bar{x})^2}{n}} = \\sqrt{\\frac{\\sum x^2}{n} - \\bar{x}^2}",
            "\\text{For grouped data:} \\quad \\bar{x} = \\frac{\\sum xf}{\\sum f}, \\quad \\text{standard deviation} = \\sqrt{\\frac{\\sum (x - \\bar{x})^2 f}{\\sum f}} = \\sqrt{\\frac{\\sum x^2 f}{\\sum f} - \\bar{x}^2}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Probability & Statistics",
        "title": "Discrete random variables",
        "formula": [
            "E(X) = \\sum x p, \\quad \\operatorname{Var}(X) = \\sum x^2 p - \\{E(X)\\}^2",
            "\\text{For the binomial distribution } B(n, p): \\quad P_r = \\binom{n}{r} p^r (1 - p)^{n - r}, \\quad \\mu = np, \\quad \\sigma^2 = np(1 - p)",
            "\\text{For the geometric distribution } \\operatorname{Geo}(p): \\quad P_r = p(1 - p)^{r - 1}, \\quad \\mu = \\frac{1}{p}",
            "\\text{For the Poisson distribution } \\operatorname{Po}(\\lambda): \\quad P_r = e^{-\\lambda} \\frac{\\lambda^r}{r!}, \\quad \\mu = \\lambda, \\quad \\sigma^2 = \\lambda"
        ]
    },
    {
        "level": "CAIE LIST MF19 Probability & Statistics",
        "title": "Continuous random variables",
        "formula": [
            "E(X) = \\int x f(x) \\, dx, \\quad \\operatorname{Var}(X) = \\int x^2 f(x) \\, dx - \\{E(X)\\}^2"
        ]
    },
    {
        "level": "CAIE LIST MF19 Probability & Statistics",
        "title": "Sampling and testing",
        "formula": [
            "\\text{Unbiased estimators:} \\quad \\bar{x} = \\frac{\\sum x}{n}, \\quad s^2 = \\frac{\\sum (x - \\bar{x})^2}{n - 1} = \\frac{1}{n - 1} \\left( \\sum x^2 - \\frac{(\\sum x)^2}{n} \\right)",
            "\\text{Central Limit Theorem:} \\quad \\bar{X} \\sim N \\left( \\mu, \\frac{\\sigma^2}{n} \\right)",
            "\\text{Approximate distribution of sample proportion:} \\quad N \\left( p, \\frac{p(1 - p)}{n} \\right)"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Probability & Statistics",
        "title": "Sampling and testing",
        "formula": [
            "\\text{Two-sample estimate of a common variance:}",
            "s^2 = \\frac{\\sum (x_1 - \\bar{x}_1)^2 + \\sum (x_2 - \\bar{x}_2)^2}{n_1 + n_2 - 2}"
        ]
    },
    {
        "level": "CAIE LIST MF19 Further Probability & Statistics",
        "title": "Probability generating functions",
        "formula": [
            "G_X (t) = E(t^X),",
            "E(X) = G'_X(1),",
            "\\operatorname{Var}(X) = G''_X(1) + G'_X(1) - \\{G'_X(1)\\}^2"
        ]
    }
]